import { msToPartDayTime } from '~/routes/utils';
import { PATH_NAMES } from '~/ocab-services/beauty/constants';

import {
  YourAddress,
} from '../routes/review';
import { YourProducts } from '../components';
import { REVIEW_YOUR_DETAILS } from '~/components/review-details/your-details/review-your-details.config';
import { YOUR_DETAILS_FIELDS_REVIEW } from '~/components/review-details/your-details/you-details-fields-review.config';

export const config = {
  editMode: {
    firstEditPagePath: PATH_NAMES.EDIT_DATE,
  },
  ReviewIntro: {
    title: 'Almost there',
    description: 'Please review your details before you complete your appointment booking.',
  },
  ReviewYourDetails: {
    displayFullName: true,
  },
  ReviewForm: {
    YourAddress,
    YourProducts,
    hideAppointmentType: true,
    hideShopDetails: true,
    formatTimeSlot: startTime => msToPartDayTime(startTime),
    yourDetailsFields: [
      REVIEW_YOUR_DETAILS[0],
      REVIEW_YOUR_DETAILS[1],
      REVIEW_YOUR_DETAILS[2],
      {
        term: 'Alternative number',
        fieldName: 'phoneNumberAlternative',
        fieldExtraProps: YOUR_DETAILS_FIELDS_REVIEW.phoneNumberAlternative,
      },
      REVIEW_YOUR_DETAILS[3],
    ],
  },
  ReviewDateTimeDetails: {
    buildAppointmentEstimationDurationDescription: duration => `Your appointment will last around ${duration}`,
  },
};
